import { FETCH_REPORT, RESET_REPORT } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const reportViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REPORT:
      return { data: action.payload };
    case RESET_REPORT:
      return initialState;
    default:
      return state;
  }
};

export default reportViewReducer;
